"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthMethod = void 0;
var AuthMethod;
(function (AuthMethod) {
    AuthMethod["NoAuth"] = "NoAuth";
    AuthMethod["BasicAuth"] = "BasicAuth";
    AuthMethod["OAuthForward"] = "OAuthForward";
    AuthMethod["CrossSiteCredentials"] = "CrossSiteCredentials";
})(AuthMethod = exports.AuthMethod || (exports.AuthMethod = {}));
//# sourceMappingURL=types.js.map